import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=78a6cc28&scoped=true"
import script from "./ForgetPassword.vue?vue&type=script&lang=ts"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts"
import style0 from "./ForgetPassword.vue?vue&type=style&index=0&id=78a6cc28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a6cc28",
  null
  
)

export default component.exports